import { CATALOG_API_URL } from "config";


export const endpoints = {
  uploadImage: (siteDomain, modelName) => `${CATALOG_API_URL}/api/v1/${siteDomain}/file/upload/image/${modelName}/`,
};
